import { useState } from "react";
import { ExportButton } from "features/brm";
import { ExportTableModal, useExportTable } from "features/exporter";
// Hooks
import { useModal } from "hooks";
// Styles
import Title from "components/elements/StyledTitle";
import ContentLayout from "brm/layout/Content/ContentLayout";
import Buttons from "components/elements/TableButtonsDivStyled";
// Local
import AttackTable from "./tables/AttackTable";

function Attack() {
  const [, setSelectedRows] = useState([]);
  const [refresh, setRefresh] = useState(true);
  const { disableExport, setExportTableData, handleTableExport } = useExportTable();
  const { isVisible, toggle } = useModal();

  const attackHeader = (
    <Title id="Attack_title">
      Attacks
      <Buttons id="Attack_buttons">
        <ExportButton onClick={() => toggle()} disableExport={disableExport} />
      </Buttons>
    </Title>
  );

  const attackMain = (
    <>
      <ExportTableModal onTableExport={handleTableExport} isVisible={isVisible} toggle={toggle} />
      <AttackTable
        setSelectedRows={setSelectedRows}
        refresh={refresh}
        setRefresh={setRefresh}
        setExportTableData={setExportTableData}
      />
    </>
  );

  return <ContentLayout pageId="Attack_page" header={attackHeader} main={attackMain} />;
}

export default Attack;
